function readFilters(PRODUCT_SOLUTIONS) {
  const dynamicPartSelect = document.getElementById('dynamicPartSelect')
  const dynamicPart = dynamicPartSelect ? dynamicPartSelect.value : ''

  const pagePropertyInput = document.getElementById('pagePropertyInput')
  const pageProperty = dynamicPart === PRODUCT_SOLUTIONS && pagePropertyInput ? pagePropertyInput.value : ''

  const searchInput = document.querySelector('.cmp-translation-search-input')
  const searchQuery = searchInput && searchInput.value ? searchInput.value.trim() : ''

  const statusInput = document.querySelector('input[name="translate_status"]:checked')
  const status = statusInput && statusInput.value ? statusInput.value : ''

  const websiteSelect = document.getElementById('websiteSelect')
  const websiteName = websiteSelect && websiteSelect.value ? websiteSelect.value : ''

  return {
    dynamicPart,
    pageProperty,
    searchQuery,
    status,
    websiteName,
  }
}

function buildQueryParams({
  page,
  pageSize,
  sizeOverride,
  dynamicPart,
  pageProperty,
  searchQuery,
  status,
  orderBy,
  orderType,
  websiteName,
  skipRedirects,
}) {
  const sizeParam = sizeOverride != null ? sizeOverride : String(pageSize)

  const params = new URLSearchParams({
    page: String(page),
    size: sizeParam,
  })

  if (dynamicPart) {
    params.append('pageName', dynamicPart)
  }
  if (websiteName) {
    params.append('websiteName', websiteName)
  }
  if (pageProperty) {
    params.append('pageProperty', pageProperty)
  }
  if (searchQuery) {
    params.append('search', searchQuery)
  }
  if (status) {
    params.append('status', status)
  }
  if (orderBy) {
    params.append('orderBy', orderBy)
  }
  if (orderType) {
    params.append('orderType', orderType)
  }
  if (skipRedirects) {
    params.append('skipRedirects', 'true')
  }

  return params
}

function extractItemsAndTotal(data) {
  const items = Array.isArray(data && data.items) ? data.items : Array.isArray(data) ? data : []

  let total = items.length
  if (typeof data === 'object' && data !== null && data.totalCount != null) {
    const parsedTotal = Number(data.totalCount)
    if (!Number.isNaN(parsedTotal)) {
      total = parsedTotal
    }
  }

  return { items, total }
}

export function fetchAllDataInternal({
  PRODUCT_SOLUTIONS,
  isFetchingData,
  pageSize,
  sizeOverride,
  setIsFetchingData,
  setCurrentData,
  setTotalCount,
  orderBy,
  orderType,
  renderTable,
  page = 1,
  skipRender = false,
  skipRedirects = false,
}) {
  if (isFetchingData) {
    return
  }

  const { dynamicPart, pageProperty, searchQuery, status, websiteName } = readFilters(PRODUCT_SOLUTIONS)

  const params = buildQueryParams({
    page,
    pageSize,
    sizeOverride,
    dynamicPart,
    pageProperty,
    searchQuery,
    status,
    orderBy,
    orderType,
    websiteName,
    skipRedirects,
  })

  setIsFetchingData(true)

  return fetch(`/bin/fetchComponentData?${params.toString()}`)
    .then(res => (res.ok ? res.json() : Promise.reject(res.status)))
    .then(data => {
      const { items, total } = extractItemsAndTotal(data)

      if (typeof setTotalCount === 'function') {
        setTotalCount(total)
      }

      setCurrentData(items)
      if (!skipRender && typeof renderTable === 'function') {
        renderTable()
      }
    })
    .catch(error => {
      console.error(error)
      if (typeof setTotalCount === 'function') {
        setTotalCount(0)
      }
      setCurrentData([])
      if (!skipRender && typeof renderTable === 'function') {
        renderTable()
      }
    })
    .finally(() => {
      setIsFetchingData(false)
    })
}
